import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { AnalyticsService } from "./analytics.service";

/**
 * Tracks SPA page views on every route change.
 *
 * Mount this component once inside `<BrowserRouter>` (e.g. in App.tsx).
 * Skips the initial render so we don't double-count with the first page load
 * that PostHog captures automatically.
 */
export function usePageViewTracker(): void {
	const location = useLocation();
	const isFirstRender = useRef(true);

	useEffect(() => {
		// Skip the very first render – PostHog captures the initial page load
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}

		AnalyticsService.pageView(
			`${window.location.origin}${location.pathname}${location.search}`,
		);
	}, [location.pathname, location.search]);
}
